/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import helpers from 'src/helpers';

import { ReactComponent as SelectDownIcon } from 'src/assets/images/select-down.svg';

import selectStatusStyle from 'src/components/View/Header/selectStatus.style';

function SelectStatus({
  classes,
  options,
  defaultTitle = 'Status',
  onChange = () => { },
  value: valueProp = null,
  selectedValue: selectedValueProp = null,
  // Additive, per-usage extras (Smart Form Entries entity filter). Defaults
  // off so every other usage of this shared select renders exactly as before.
  // dropdownStyle: inline style for the open menu (e.g. content-fit width).
  // showSelectedDot: render the selected option's dotColor inside the closed
  // control, ahead of its name.
  dropdownStyle = null,
  showSelectedDot = false,
}) {
  const [openSelect, setOpenSelect] = useState(false);
  const elRef = useRef(null);

  // Decide which prop controls display, or fallback to active flag
  const controlledValue = selectedValueProp != null
    ? selectedValueProp
    : valueProp != null
      ? valueProp
      : null;

  // Determine which option to show
  const selectedOption = (controlledValue != null
    ? options.find((opt) => opt.value === controlledValue)
    : options.find((opt) => opt.active)) || {};

  const handleClickAnywhere = (e) => {
    if (elRef?.current && !elRef.current.contains(e.target)) {
      setOpenSelect(false);
      document.removeEventListener('click', handleClickAnywhere);
    }
  };

  const handleClick = () => {
    setOpenSelect(!openSelect);
    if (!openSelect) {
      document.addEventListener('click', handleClickAnywhere);
      return;
    }
    document.removeEventListener('click', handleClickAnywhere);
  };

  const handleCheck = (opt) => {
    if (opt.value !== selectedOption.value) {
      onChange(opt);
    }
    setOpenSelect(false);
  };

  useEffect(() => () => document.removeEventListener('click', handleClickAnywhere), []);

  return (
    <div
      className={`${classes.root} inner`}
      onClick={handleClick}
      ref={elRef}
    >
      {showSelectedDot && selectedOption.dotColor && (
        <span
          style={{
            flexShrink: 0,
            alignSelf: 'center',
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: selectedOption.dotColor,
            marginRight: 8,
          }}
        />
      )}
      <input
        disabled
        className="input"
        value={selectedOption.title || defaultTitle}
      />
      <div className="iconRight">
        <SvgIcon
          className="svgIcon"
          component={SelectDownIcon}
          viewBox="0 0 24 24"
        />
      </div>
      {openSelect && (
        <div
          className={classes.innerFieldDropDown}
          style={dropdownStyle || undefined}
        >
          {helpers.transform.toArray(options).map((item) => (
            <button
              key={item.value}
              className={`selectButton${item.value === selectedOption.value ? ' checked' : ''}`}
              onClick={() => {
                handleCheck(item);
              }}
              type="button"
            >
              {item.dotColor && (
                <span
                  style={{
                    display: 'inline-block',
                    width: 8,
                    height: 8,
                    borderRadius: '50%',
                    backgroundColor: item.dotColor,
                    marginRight: 8,
                    verticalAlign: 'middle',
                  }}
                />
              )}
              {item.title}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

SelectStatus.propTypes = {
  classes: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  defaultTitle: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),
  selectedValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),
  dropdownStyle: PropTypes.object,
  showSelectedDot: PropTypes.bool,
};

export default withStyles(SelectStatus, selectStatusStyle, { withTheme: true });
